import { validateDateNotInFuture } from '../../../utils/validators';
import { NO_EMPLOYER_INFO_STATUSES } from './constants';

const SecondEmployerSection = {
  name: 'secondEmployer',
  title: "APPLICANT'S 2ND CURRENT EMPLOYER",
  container: 'collapse',
  GridProps: { xs: 12, marginTop: 2 },
  watchFields: ['employmentStatus', 'secondJobDoesNotApply'],
  hidden: ({ getValues }) => !getValues('employmentStatus'),
  collapsed: ({ getValues }) =>
    NO_EMPLOYER_INFO_STATUSES.includes(getValues('employmentStatus')) ||
    getValues('secondJobDoesNotApply') === true ||
    getValues('secondJobDoesNotApply') === 'on',
  disabled: ({ getValues }) =>
    NO_EMPLOYER_INFO_STATUSES.includes(getValues('employmentStatus')) ||
    getValues('secondJobDoesNotApply') === true ||
    getValues('secondJobDoesNotApply') === 'on',
  fields: [
    {
      variant: 'checkbox',
      name: 'secondJobDoesNotApply',
      label: 'Does Not Apply (N/A)',
      overrideParentDisabled: true,
      watchFields: ['employmentStatus'],
      disabled: ({ getValues }) =>
        NO_EMPLOYER_INFO_STATUSES.includes(getValues('employmentStatus')),
      GridProps: { xs: 12 },
      changeActions: [
        {
          type: 'updateField',
          target: 'secondJobPosition',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'secondJobAnnualSalary',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'secondJobStartDate',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'secondJobEmployerName',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'secondJobEmployerPhone',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'secondJobSupervisorName',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'secondJobStreetAddress',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'secondJobCity',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'secondJobState',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'secondJobZipCode',
          value: '',
          when: {
            eq: true,
          },
        },
      ],
    },
    {
      variant: 'text',
      name: 'secondJobPosition',
      label: 'Position',
      rules: {
        required: true,
      },
      GridProps: { xs: 12, sm: 4 },
    },
    {
      variant: 'currency',
      name: 'secondJobAnnualSalary',
      label: 'Annual Income',
      GridProps: { xs: 12, sm: 3 },
      rules: {
        required: true,
        min: 0.01,
      },
    },
    {
      variant: 'date',
      name: 'secondJobStartDate',
      label: 'Start Date',
      GridProps: { xs: 12, sm: 2 },
      rules: {
        required: true,
        validate: (value) => {
          return validateDateNotInFuture(value, 'Start Date');
        },
      },
    },
    {
      variant: 'flexSpacer',
    },
    {
      variant: 'text',
      name: 'secondJobEmployerName',
      label: 'Employer Name',
      GridProps: { xs: 12, sm: 4 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'phone',
      name: 'secondJobEmployerPhone',
      label: 'Employer Phone',
      GridProps: { xs: 12, sm: 3 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'text',
      name: 'secondJobSupervisorName',
      label: 'Supervisor Name',
      GridProps: { xs: 12, sm: 4 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'flexSpacer',
    },
    {
      variant: 'text',
      name: 'secondJobStreetAddress',
      label: 'Employer Street Address',
      GridProps: { xs: 12, sm: 4 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'text',
      name: 'secondJobCity',
      label: 'City',
      GridProps: { xs: 12, sm: 3 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'singleSelect',
      name: 'secondJobState',
      label: 'State/Province',
      GridProps: { xs: 12, sm: 3 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'text',
      name: 'secondJobZipCode',
      label: 'Zip Code/Postal Code',
      GridProps: { xs: 12, sm: 2 },
      rules: {
        required: true,
      },
    },
  ],
};

export default SecondEmployerSection;
